<app-page-header
  class="header"
  [inside]="true"
  [backSwipe]="backSwipeConfig"
  (backButtonClick)="back.emit()"
/>

<div class="content">
  <div class="info">
    <span class="title">Ready to roll?</span>
    <span class="text green">Reserve Your Lane in Seconds!</span>
    <span class="text">Skip the wait. Lock in your game time now.</span>
  </div>
  <div class="link">
    <app-qrcode content="https://oon.gl/tSnSxa" [size]="278"/>
    <span class="label">Scan the QR Code</span>
    <span>to Reserve Your Lane</span>
  </div>
</div>
